'use client'

import {Select, SelectProps} from 'antd'
import React from 'react'
import styled from 'styled-components'

export const SelectStyled: StyledOverride<typeof Select> = styled(Select)``

const RunlabSelect = (props: SelectProps) => {
  return <SelectStyled {...props} />
}

export default RunlabSelect
